// Object.keys
if (!Object.keys) {
  Object.keys = function(object) {
    var keys = [];
    for (var name in object) {
      if (Object.prototype.hasOwnProperty.call(object, name)) {
        keys.push(name);
      }
    }
    return keys;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/Object.keys.js
// module id = 64
// module chunks = 0